import { Toman } from '@/components/svg-symbols/icons';
import { VariantContextType } from '@/app/(pdp)/context/types';
import { toNumberCommas } from '@/utils/string-helpers';
import { GoldPricingDetail } from './gold-pricing-detail';
import { PricingType } from '../types';
interface Props extends PricingType {
  withGoldPricing?: boolean;
  contextType: VariantContextType;
}
export const AppButtonPricing = ({
  basePrice = 0,
  discountPercent = 0,
  effectivePrice = 0,
  withGoldPricing = false,
  contextType
}: Props) => {
  const hasDiscount = !!discountPercent;
  return <div className='flex w-fit flex-col items-center gap-1 lg:gap-1.5' data-sentry-component="AppButtonPricing" data-sentry-source-file="app-button-pricing.tsx">
            <div className='flex items-center lg:gap-1'>
                {!!hasDiscount && <span className='px-2 text-center text-body-14 text-text-mediumGray line-through'>
                        {toNumberCommas(basePrice)}
                    </span>}
                {hasDiscount && <span className='flex w-10 items-center justify-center rounded-md bg-alert-error-dark px-1.5 pt-0.5 text-center text-body-14 font-medium leading-[22px] text-text-white lg:w-10'>
                        {discountPercent}٪
                    </span>}
            </div>

            <div className='flex items-center gap-1'>
                {withGoldPricing && <GoldPricingDetail contextType={contextType} />}

                <span className='text-body-14 font-medium text-text-black lg:text-body-16'>
                    {toNumberCommas(effectivePrice || basePrice)}
                </span>

                <Toman className='h-5 w-5 text-text-black lg:h-6 lg:w-6' data-sentry-element="Toman" data-sentry-source-file="app-button-pricing.tsx" />
            </div>
        </div>;
};